// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"effebf97","453":"acd32cbf"}[chunkId] + ".chunk.js";
};